import styled from "styled-components";
const bp = { md: "768px" };

export const Container = styled.div`
  min-height: 100vh;
  padding: 70px 20px 80px;
`;

export const Header = styled.div`
  max-width: 980px;
  margin: 0 auto 30px;
  text-align: center;
`;

export const Title = styled.h1`
  margin: 6px 0 10px;
  font-family: "Cormorant Garamond", serif;
  font-weight: 650;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  font-size: 30px;
  color: rgba(0, 0, 0, 0.92);

  @media (max-width: ${bp.md}) {
    font-size: 26px;
  }
`;

export const Ornament = styled.div`
  position: relative;
  width: 260px;
  height: 14px;
  margin: 6px auto 14px;
`;

export const OrnLine = styled.span`
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  height: 2px;
  transform: translateY(-50%);
  background: rgba(201, 162, 39, 0.42);
  border-radius: 999px;
`;

export const OrnDiamond = styled.span`
  position: absolute;
  left: 50%;
  top: 50%;
  width: 10px;
  height: 10px;
  transform: translate(-50%, -50%) rotate(45deg);
  background: #c9a227;
  border-radius: 2px;

  box-shadow:
    0 0 0 3px rgba(201, 162, 39, 0.14),
    0 1px 2px rgba(0, 0, 0, 0.12);
`;

export const SectionCard = styled.div`
  max-width: 860px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 0.72);
  border: 1px solid rgba(201, 162, 39, 0.28);
  border-radius: 30px;
  padding: 34px 28px;
  backdrop-filter: blur(4px);
  box-shadow: 0 18px 48px rgba(0, 0, 0, 0.06);

  @media (max-width: 768px) {
    padding: 22px 16px;
    border-radius: 22px;
  }
`;

export const Form = styled.form`
  display: grid;
  gap: 20px;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 22px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  color: #1c1814;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 0.98rem;
  font-weight: 700;
`;

export const Input = styled.input`
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  min-height: 60px;
  padding: 0 18px;
  border-radius: 20px;
  border: 1px solid rgba(30, 24, 18, 0.12);
  background: rgba(255, 255, 255, 0.55);
  color: #1a1714;
  font-size: 1rem;
  outline: none;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease;
`;

export const CheckboxContainer = styled.div`
  display: grid;
  gap: 14px;
  margin-top: 6px;
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  color: #2a241e;
  font-size: 0.95rem;
  line-height: 1.55;
`;

export const Checkbox = styled.input`
  width: 16px;
  height: 16px;
  margin-top: 4px;
  accent-color: #c9a227;
  flex: 0 0 auto;
`;

export const CheckboxError = styled.span`
  color: #c62828;
  font-size: 0.84rem;
  margin-top: -6px;
`;

export const SubmitButton = styled.button`
  min-height: 56px;
  margin-top: 10px;
  border: none;
  border-radius: 999px;
  background: linear-gradient(135deg, #181512 0%, #2b241d 100%);
  color: #fff;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  cursor: pointer;
  transition:
    transform 0.18s ease,
    box-shadow 0.2s ease,
    opacity 0.2s ease;
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.14);

  &:hover {
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.7;
    cursor: wait;
    transform: none;
  }
`;

export const Note = styled.p`
  margin: 0;
  color: rgba(24, 21, 18, 0.62);
  font-size: 0.88rem;
  line-height: 1.6;
`;

export const DateInputWrap = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  border-radius: 20px;
`;

export const DateInput = styled(Input).attrs({ type: "date" })`
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  appearance: none;
  -webkit-appearance: none;
  padding-right: 54px;

  &::-webkit-date-and-time-value {
    text-align: left;
  }

  &::-webkit-calendar-picker-indicator {
    position: absolute;
    right: 18px;
    top: 50%;
    transform: translateY(-50%);
    width: 22px;
    height: 22px;
    margin: 0;
    padding: 0;
    cursor: pointer;
  }

  @media (max-width: 768px) {
    min-height: 58px;
    padding-left: 16px;
    padding-right: 50px;
    font-size: 16px;

    &::-webkit-calendar-picker-indicator {
      right: 16px;
    }
  }
`;

export const CalendarIcon = styled.span`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  display: grid;
  place-items: center;
  pointer-events: none;
  color: #3d3d3d;
  z-index: 2;

  svg {
    width: 18px;
    height: 18px;
  }
`;
